// extracted by mini-css-extract-plugin
module.exports = {"nfts_page":"NFTPage_nfts_page__3mAq1","loading_screen":"NFTPage_loading_screen__26lvT","loading_text":"NFTPage_loading_text__1iI2R"};